/**
 * Classic Feather has no "building" icon. This SVG matches Feather/Lucide style
 * so Site Management can use <i-feather name="building">.
 */
export const Building =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather feather-building" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
  '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>' +
  '<path d="M9 22v-4h6v4"></path>' +
  '<path d="M8 6h.01"></path>' +
  '<path d="M16 6h.01"></path>' +
  '<path d="M12 6h.01"></path>' +
  '<path d="M12 10h.01"></path>' +
  '<path d="M12 14h.01"></path>' +
  '<path d="M16 10h.01"></path>' +
  '<path d="M16 14h.01"></path>' +
  '<path d="M8 10h.01"></path>' +
  '<path d="M8 14h.01"></path>' +
  '</svg>';
